import { carryViewApplied } from '@/lib/url-state/last-view';

/**
 * SF-T-134: a sub-task opened from its parent's list carries this mark in its history entry, so
 * closing it goes Back to the parent (the entry behind it) instead of to the list. A sub-task opened
 * any other way (the Board, a link) has no mark and closes as before.
 */
const FROM_PARENT = 'sfFromParentTask';

/** The history state for a sub-task link: the saved-view mark carried over, plus "opened from its parent". */
export function fromParentState(state: unknown): Record<string, unknown> {
  return { ...carryViewApplied(state), [FROM_PARENT]: true };
}

export function openedFromParent(state: unknown): boolean {
  return (state as Record<string, unknown> | null)?.[FROM_PARENT] === true;
}
